/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconLetterR = createReactComponent("outline", "letter-r", "IconLetterR", [["path", { "d": "M7 20v-16h5.5a4 4 0 0 1 0 9h-5.5", "key": "svg-0" }], ["path", { "d": "M12 13l5 7", "key": "svg-1" }]]);

export { IconLetterR as default };
//# sourceMappingURL=IconLetterR.mjs.map
